export default function HBAFBrandSection() {
  return (
    <section className="mt-20 border-t border-gray-100 pt-16">
      {/* Brand Header */}
      <div className="text-center mb-14">
        <span
          className="inline-block text-[11px] font-bold tracking-[0.3em] uppercase px-4 py-1.5 rounded-full mb-6"
          style={{ backgroundColor: '#FFF8E1', color: '#E6A800' }}
        >
          Brand Story
        </span>
        {/* HBAF 로고 */}
        <div className="flex items-center justify-center mb-4">
          <h2 className="text-4xl md:text-5xl font-black tracking-tight" style={{ color: '#1A1A1A', fontFamily: 'Impact, Arial Black, sans-serif', letterSpacing: '-0.02em' }}>
            HBAF
          </h2>
        </div>
        <p className="text-base font-bold tracking-widest" style={{ color: '#E6A800' }}>
          Healthy But Awesome Flavors
        </p>
        <p className="mt-1 text-sm text-gray-400 tracking-wider">
          健康而美味 · 韩国最大坚果品牌 / 한국 최대 견과류 브랜드
        </p>
        <p className="mt-4 text-[14px] text-gray-500 leading-relaxed max-w-2xl mx-auto">
          健康又美味！韩国最大坚果品牌HBAF推出的优质零食阵容
        </p>
        <p className="text-[13px] text-gray-400 leading-relaxed max-w-2xl mx-auto mt-1">
          건강하면서도 맛있는 것! 한국 최대 견과류 브랜드 HBAF가 선보이는 프리미엄 스낵 라인업
        </p>
      </div>

      {/* Hero Banner */}
      <div
        className="rounded-3xl overflow-hidden mb-12"
        style={{ background: 'linear-gradient(135deg, #1A1A1A 0%, #2C2C2C 60%, #3A3000 100%)' }}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          {/* Left: Brand Story */}
          <div className="p-10 lg:p-14 flex flex-col justify-center">
            <span
              className="inline-block text-[10px] font-bold tracking-[0.3em] uppercase px-3 py-1 rounded-full mb-6 w-fit"
              style={{ backgroundColor: 'rgba(230,168,0,0.15)', color: '#E6A800' }}
            >
              Korea&apos;s Largest Nut Brand
            </span>
            <h3 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4 tracking-tight">
              H is silent,<br />
              <span className="text-2xl font-bold" style={{ color: '#E6A800' }}>My best friend, My HBAF</span>
            </h3>
            <p className="text-[13px] leading-relaxed mb-2" style={{ color: '#7A6A00' }}>
              健康而美味 / Healthy But Awesome Flavors
            </p>
            <p className="text-[14px] text-gray-300 leading-relaxed mt-4">
              HBAF从分享一小袋零食的年纪出发，成长为韩国最大坚果品牌，持续扩大全球出口规模。
            </p>
            <p className="text-[13px] leading-relaxed mt-2" style={{ color: '#5A5000' }}>
              HBAF는 마른 한 봉 나눠 먹을 나이에서 시작된 품질로, 매년 꾸준히 수출에서 매년 성장하고 있는 국내 최대 견과류 브랜드입니다.
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              {[
                { zh: '扁桃仁', ko: '아몬드' },
                { zh: '花生', ko: '땅콩' },
                { zh: '混合坚果', ko: '믹스넛' },
                { zh: '蛋白棒', ko: '프로틴바' },
                { zh: '爆米花', ko: '팝콘' },
              ].map((tag) => (
                <span
                  key={tag.zh}
                  className="text-[11px] px-3 py-1 rounded-full font-medium"
                  style={{ backgroundColor: 'rgba(230,168,0,0.12)', color: '#E6A800', border: '1px solid rgba(230,168,0,0.2)' }}
                >
                  {tag.zh} <span style={{ opacity: 0.6 }}>/ {tag.ko}</span>
                </span>
              ))}
            </div>
          </div>

          {/* Right: Brand Values */}
          <div
            className="p-10 lg:p-14 flex flex-col justify-center gap-5"
            style={{ borderLeft: '1px solid rgba(255,255,255,0.06)' }}
          >
            {[
              {
                num: '01',
                titleZh: '40年传统品质',
                titleKo: '40년 전통 품질',
                descZh: '40余年丰富经验，持续研发产品与包装设计，每年为季节限定农产品挑战未来',
                descKo: '40년이 넘는 풍부한 경험, 지속적인 제품 개발과 포장 디자인, 매년 시즌 한정 농산물에 대하여 미래를 준비하는 도전 정신',
              },
              {
                num: '02',
                titleZh: '韩国最大坚果品牌',
                titleKo: '국내 최대 견과류 브랜드',
                descZh: '以合理价格提供国内最高品质坚果和健康零食的韩国代表品牌',
                descKo: '국내 최고 품질의 견과류와 건강 스낵을 합리적인 가격으로 제공하는 대한민국 대표 브랜드',
              },
              {
                num: '03',
                titleZh: '全球出口品牌',
                titleKo: '글로벌 수출 브랜드',
                descZh: '出口中国、日本、东南亚等全球市场的K-零食代表品牌',
                descKo: '중국, 일본, 동남아 등 전 세계로 수출되는 K-스낵 대표 브랜드',
              },
            ].map((item) => (
              <div key={item.num} className="flex gap-4">
                <span
                  className="text-[11px] font-black shrink-0 mt-0.5"
                  style={{ color: '#E6A800' }}
                >
                  {item.num}
                </span>
                <div>
                  <p className="text-[13px] font-bold text-white mb-0.5">{item.titleZh}</p>
                  <p className="text-[11px] mb-1.5" style={{ color: '#7A6A00' }}>{item.titleKo}</p>
                  <p className="text-[12px] leading-relaxed" style={{ color: '#8A8070' }}>{item.descZh}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Product Lines */}
      <div className="mb-12">
        <h4
          className="text-[11px] font-bold tracking-[0.25em] uppercase text-center mb-6"
          style={{ color: '#8C7D00' }}
        >
          Product Lines · 제품 라인업
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            {
              icon: 'ri-seedling-line',
              name: 'HBAF Classic',
              nameZh: '经典系列',
              nameKo: '클래식',
              descZh: '扁桃仁、花生等经典坚果系列',
              descKo: '아몬드, 땅콩 등 클래식 견과류 라인',
              color: '#FFFBEA',
            },
            {
              icon: 'ri-heart-pulse-line',
              name: 'MON TO SUN',
              nameZh: '每日健康系列',
              nameKo: '데일리 헬스',
              descZh: '每天食用的健康日常零食',
              descKo: '매일 먹는 건강한 데일리 스낵',
              color: '#FFF3E0',
            },
            {
              icon: 'ri-restaurant-line',
              name: 'NUTS & SNACKS',
              nameZh: '坚果零食系列',
              nameKo: '너츠&스낵',
              descZh: '爆米花、蛋白棒等多样零食',
              descKo: '팝콘, 프로틴바 등 다양한 스낵',
              color: '#FFF8E1',
            },
          ].map((line) => (
            <div
              key={line.name}
              className="rounded-2xl p-6 text-center"
              style={{ backgroundColor: line.color, border: '1px solid rgba(230,168,0,0.15)' }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl mx-auto mb-3 bg-white/70">
                <i className={`${line.icon} text-xl`} style={{ color: '#E6A800' }}></i>
              </div>
              <p className="text-[14px] font-black text-gray-800">{line.name}</p>
              <p className="text-[11px] font-semibold mb-1" style={{ color: '#B8860B' }}>{line.nameZh} / {line.nameKo}</p>
              <p className="text-[12px] text-gray-700 leading-relaxed">{line.descZh}</p>
              <p className="text-[11px] mt-1" style={{ color: '#A08000' }}>{line.descKo}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Brand Values */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {[
          {
            icon: 'ri-award-line',
            titleZh: '国内坚果第一',
            titleKo: '국내 견과류 1위',
            descZh: '韩国坚果市场占有率第一品牌',
            descKo: '대한민국 견과류 시장 점유율 1위 브랜드',
          },
          {
            icon: 'ri-global-line',
            titleZh: '全球出口',
            titleKo: '글로벌 수출',
            descZh: '出口中国·日本·东南亚等全球市场',
            descKo: '중국·일본·동남아 등 전 세계 수출',
          },
          {
            icon: 'ri-leaf-line',
            titleZh: '健康原材料',
            titleKo: '건강한 원재료',
            descZh: '仅使用精选优质原材料',
            descKo: '엄선된 프리미엄 원재료만 사용',
          },
          {
            icon: 'ri-shield-check-line',
            titleZh: '安全生产',
            titleKo: '안전한 제조',
            descZh: 'HACCP认证工厂卫生生产',
            descKo: 'HACCP 인증 공장에서 위생적으로 생산',
          },
        ].map((item) => (
          <div
            key={item.titleZh}
            className="rounded-2xl p-6 text-center"
            style={{ backgroundColor: '#FAFAF8', border: '1px solid #EDE8D0' }}
          >
            <div
              className="w-12 h-12 flex items-center justify-center rounded-2xl mx-auto mb-4"
              style={{ backgroundColor: '#FFF8E1' }}
            >
              <i className={`${item.icon} text-xl`} style={{ color: '#B8860B' }}></i>
            </div>
            <p className="text-[13px] font-bold text-gray-800 mb-0.5">{item.titleZh}</p>
            <p className="text-[11px] mb-2" style={{ color: '#A08000' }}>{item.titleKo}</p>
            <p className="text-[12px] text-gray-500 leading-relaxed">{item.descZh}</p>
          </div>
        ))}
      </div>

      {/* Storage & Info */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
        <div
          className="rounded-2xl p-8"
          style={{ backgroundColor: '#FFFDF0', border: '1px solid #EDE8C0' }}
        >
          <h4
            className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5"
            style={{ color: '#A08000' }}
          >
            储存方法 · 보관 방법
          </h4>
          <div className="space-y-4">
            {[
              { step: '01', zh: '避免直射阳光，存放在阴凉干燥处', ko: '직사광선을 피해 서늘하고 건조한 곳에 보관' },
              { step: '02', zh: '开封后密封，建议尽快食用', ko: '개봉 후 밀봉하여 빠른 시일 내 섭취 권장' },
              { step: '03', zh: '常温保存（无需冷藏）', ko: '상온 보관 (냉장 보관 불필요)' },
              { step: '04', zh: '在保质期内食用（自生产日起12个月）', ko: '유효기간 내 섭취 (제조일로부터 12개월)' },
            ].map((item) => (
              <div key={item.step} className="flex items-start gap-3">
                <span
                  className="text-[11px] font-black shrink-0 w-6 h-6 flex items-center justify-center rounded-full text-white"
                  style={{ backgroundColor: '#B8860B' }}
                >
                  {item.step}
                </span>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px]" style={{ color: '#A08000' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          className="rounded-2xl p-8"
          style={{ backgroundColor: '#FFFDF0', border: '1px solid #EDE8C0' }}
        >
          <h4
            className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5"
            style={{ color: '#A08000' }}
          >
            B2B应用领域 · B2B 활용 분야
          </h4>
          <div className="space-y-3">
            {[
              { zh: '酒店·度假村客房礼品及迷你吧供货', ko: '호텔·리조트 어메니티 및 미니바 납품' },
              { zh: '航空公司机上餐食及零食供货', ko: '항공사 기내식 및 스낵 납품' },
              { zh: '便利店·超市自有品牌及大批量供货', ko: '편의점·마트 PB 상품 및 대량 납품' },
              { zh: '企业福利商城·礼品套装供货', ko: '기업 복지몰·선물세트 납품' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div
                  className="w-5 h-5 flex items-center justify-center rounded-full shrink-0 mt-0.5"
                  style={{ backgroundColor: '#B8860B' }}
                >
                  <i className="ri-check-line text-white text-[10px]"></i>
                </div>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px]" style={{ color: '#A08000' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Awards */}
      <div className="rounded-2xl p-8" style={{ backgroundColor: '#1A1A1A' }}>
        <h4
          className="text-[11px] font-bold tracking-[0.25em] uppercase mb-6 text-center"
          style={{ color: '#E6A800' }}
        >
          Awards &amp; Recognition · 수상 및 인정
        </h4>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { icon: 'ri-award-fill', titleZh: '坚果销量第一', titleKo: '견과류 판매 1위', year: '2024' },
            { icon: 'ri-medal-line', titleZh: '消费者满意大奖', titleKo: '소비자 만족 대상', year: '2023' },
            { icon: 'ri-global-line', titleZh: '出口优秀品牌', titleKo: '수출 우수 브랜드', year: '2023' },
            { icon: 'ri-star-line', titleZh: 'Olive Young最佳', titleKo: '올리브영 베스트', year: '2024' },
          ].map((item) => (
            <div
              key={item.titleZh}
              className="text-center p-4 rounded-xl"
              style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(230,168,0,0.12)' }}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3"
                style={{ backgroundColor: 'rgba(230,168,0,0.12)' }}
              >
                <i className={`${item.icon} text-lg`} style={{ color: '#E6A800' }}></i>
              </div>
              <p className="text-[12px] font-bold text-white mb-0.5">{item.titleZh}</p>
              <p className="text-[10px] mb-1" style={{ color: '#7A6A00' }}>{item.titleKo}</p>
              <span
                className="text-[10px] font-bold px-2 py-0.5 rounded-full"
                style={{ backgroundColor: 'rgba(230,168,0,0.1)', color: '#E6A800' }}
              >
                {item.year}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
